import moment from "moment";
export const INIT_FILTER_STATE = {
  startDate: moment().subtract(30, "days").toDate(),
  endDate: moment().subtract(1, "days").toDate(),
  // startDate: moment(new Date("2022-07-01T00:00:00.000Z")).toDate(),
  // endDate: moment(new Date("2023-08-31T00:00:00.000Z")).toDate(),
  VIN_NUM: [],
  CITY: [],
  LOB: [],
  PPL: [],
  PL: [],
  SOC: 0,
  pageSelected: 1,
  ODOMETER: 0,
  DISCHARGE: 0,
  DELTA: 0,
};

export const INIT_FILTER_STATE_DRIVE = {
  // startDate: moment().subtract(30, "days").toDate(),
  endDate: moment().subtract(1, "days").toDate(),
  startDate: moment(new Date("2022-07-01T00:00:00.000Z")).toDate(),
  // endDate: moment(new Date("2023-08-31T00:00:00.000Z")).toDate(),
  VIN_NUM: [],
  CITY: [],
  LOB: [],
  PPL: [],
  PL: [],
  SOC: 0,
  pageSelected: 1,
  ODOMETER: 0,
  DISCHARGE: 0,
  DELTA: 0,
};

// export const API_URL_MAIN = "https://fleetascents.dev.ev.cv.tatamotors/api/";
export const API_URL_MAIN = process.env.REACT_APP_BASE_URL;
// export const API_URL_MAIN = "https://fleetascents.dev.ev.tatamotors.com/api/";
// export const API_URL_MAIN = "http://10.164.59.172:5053/api/";

export const INIT_STATE_SELECTS = {
  startDate: moment().subtract(30, "days").toDate(),
  endDate: moment().subtract(1, "days").toDate(),
  // startDate: moment(new Date("2022-07-01T00:00:00.000Z")).toDate(),
  // endDate: moment(new Date("2023-08-31T00:00:00.000Z")).toDate(),
  VIN_NUM: [],
  CITY: [],
  LOB: [],
  PPL: [],
  PL: [],
  SOC: 0,
  pageSelected: 1,
  ODOMETER: 0,
  DISCHARGE: 0,
  DELTA: 0,
};

export const INDEX = {
  CITY_INDEX: "CITY",
  LOB_INDEX: "LOB",
  PPL_INDEX: "PPL",
  PL_INDEX: "PL",
  SOC_INDEX: "SOC",
  ODOMETER_INDEX: "ODOMETER",
  DISCHARGE_INDEX: "DISCHARGE",
  DELTA_INDEX: "DELTA",
};
